export const buildTime = (hours: string, mins: string, t2: (key: string) => string) => {
  if (!hours || !mins) {
    return `N/A`;
  }
  return `${hours} ${t2('hour')}(s) con ${mins} minutos`;
};
